// import * as parser from 'rss-parser';
import Alert from '../classes/alert';

export default class FetchRSS {
    static async do(showNotification = true) {
        let result = null;

        // var myHeaders = new Headers()
        // myHeaders.append('Accept', 'application/rss+xml');
        var myInit = { method: 'GET',
                       headers: new Headers(),
                       mode: 'cors' };
        await fetch(
            'https://query.yahooapis.com/v1/public/yql?q=select%20*%20from%20xml%20where%20url%20%3D%20%27http%3A%2F%2Fcontent.warframe.com%2Fdynamic%2Frss.php%27&format=json&diagnostics=true&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys&callback='
            , myInit)
            .then(response => response.json()).then(json => {
                if(json.query.results)
                    result = json.query.results.rss.channel.item;
            });

        if(result) {
            result = result.filter(item => item.author === "Alert").map(item => new Alert(item));
        
            let oldItems = this.getItems();

            let newItems = result.filter(item => !oldItems.find(old => old.guid === item.guid) &&  !item.hasExpired());
            let filteredNew = this.filter(newItems);
            if(filteredNew.length > 0) {
                let notifications = [];
                filteredNew.forEach((item) => {
                    item.unread = true;
                    if(window.Notification && showNotification) {
                        let options = {
                            body: (item.drop ? item.credits + ' - ' : '') + item.location + ' - ' + item.getExpires()+'m',
                            icon: item.getImg()
                        };
                        notifications.push(new Notification(item.drop ? item.drop : item.credits, options));
                    }
                }, this);
                setTimeout(() => {
                    for(let n of notifications) {
                        n.close();
                    }
                },5000)
                console.log('adding '+filteredNew.length+' items');
            }
            result = oldItems.concat(newItems);
            this.save(result);
        }

        return result ? result : [];
    }

    static getItems() {
        
        let oldItems = [];
        
        if(localStorage.items)
            oldItems = JSON.parse(localStorage.items);
        if(oldItems) {
            oldItems = oldItems.map(item => new Alert(item.rss)).filter(item => !item.hasExpired());
        }
        return oldItems ? oldItems : [];
    }

    static filter(items) {
        let filter = this.getFilter();

        return items.filter(item => {
            if(!filter.blueprints && item.drop && item.drop.indexOf('(Blueprint)') > -1)
                return false;
            if(!filter.resources && item.drop && item.drop.indexOf('(Resource)') > -1)
                return false;
            if(!filter.endo && item.drop && item.drop.indexOf('ENDO') > -1)
                return false;
            if(!filter.auras && item.drop && item.getType() === 5)
                return false;
            if(!filter.credits && !item.drop)
                return false;
            return true;
        });
    }

    static getFilter() {
        let filter =  {
            blueprints: true,
            auras: true,
            resources: true,
            credits: true,
            endo: true
        }
        if(localStorage.filter)
            filter = JSON.parse(localStorage.filter);
        return filter
    }

    static saveFilter(filter) {
        localStorage.filter = JSON.stringify(filter);
    }

    static save(items) {
        // console.log('Saving new item(s)');
        localStorage.setItem('items', JSON.stringify(items));
    }
}


// WEBPACK FOOTER //
// ./src/actions/fetchrss.js